import React from "react";

class WebsiteButton extends React.Component {
  render() {
    return (
      <button
        className="btn_website"
        onClick={() => {
          window.open(this.props.websiteUrl, "_blank");
        }}
      >
        <div className="label">Visit Doctor's Website</div>
      </button>
    );
  }
}

export default WebsiteButton;
